import { themeVars } from '@coverflex-tech/hypernova';
import { globalStyle, style } from '@vanilla-extract/css';

const table = style({
  tableLayout: 'fixed',
});

const iconCell = style({
  width: '4rem',
  paddingRight: 0,
});

const descriptionCell = style({
  width: '100%',
});

const statusCell = style({
  width: '20rem',
  whiteSpace: 'nowrap',
});

const amountCell = style({
  width: '12.8rem',
  fontWeight: 'bold',
  whiteSpace: 'nowrap',
});

const amountCredit = style({
  color: themeVars.color.semantic.text.systemSuccess,
});

const amountDisabled = style({
  textDecoration: 'line-through',
  color: themeVars.color.semantic.text.neutral20,
  fontWeight: 'normal',
});

const disabledCell = style({
  color: themeVars.color.semantic.text.neutral20,
});

globalStyle(`${disabledCell} svg`, {
  color: themeVars.color.semantic.text.neutral20,
});

const chevronCell = style({
  width: '4rem',
  paddingLeft: 0,
});

export const css = {
  table,
  iconCell,
  descriptionCell,
  statusCell,
  amountCell,
  amountCredit,
  amountDisabled,
  disabledCell,
  chevronCell,
};
